import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import "./NotFoundPage.css";
import { useSeo } from "../../utils/Hooks/useSeo";

export function NotFoundPage() {
  useSeo({
    title: "404 - Page Not Found",
    description: "The requested page was not found on In Bitcoin Terms.",
    canonicalPath: "/404",
    robots: "noindex,follow",
  });
  
  return (
    <>
      <Header title="In Bitcoin Terms" />
      <main className="notfound-page">
        <section className="notfound-card">
          <h1>404 - Page Not Found</h1>
          <p>Sorry, the page you are looking for does not exist.</p>
          <div className="notfound-actions">
            <Link to="/" className="notfound-home-link">
              Back to Home
            </Link>
            <Link to="/convert" className="notfound-secondary-link">
              Open Converter
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}
